import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SectionHeading' })({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 24,
        borderRadius: 16,
        border: '1px solid #ECECEC'
    },
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flex: 1
    },
    titleItem: {
        color: '#2D2D2D',
        fontSize: 28,
        fontWeight: 700,
        lineHeight: '42px',
        letterSpacing: '-0.84px'
    },
    total: {
        color: '#F5726A',
        fontSize: 22,
        fontWeight: 600,
        lineHeight: '33px',
        letterSpacing: '-0.66px',
        marginTop: 2,
        marginLeft: 4,
        display: 'inline-flex'
    }
});
